<template>
  <RouterLink  :to="{name:'chart-dashboard-editor',params:{pageId:1}}">
             <span class="flex items-center space-x-2 py-1 px-3 hover:fill-primary hover:text-primary text-xs">
               <IconLinkGraphs/>
             <span> My Graphs</span></span>
  </RouterLink>
</template>

<script setup lang="ts">

import IconLinkGraphs from "@/components/svg_icons/IconLinkGraphs.vue";

</script>

<style scoped>

</style>